import { Component, signal, inject, input, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DecayMetric } from '../../services/metric.service';
import { VisualBaseComponent } from '../../visuals/visual-base.component';
import { SessionService } from '../../../shared/services/session.service';
import { StateService } from '../../services/state.service';
import { FilterTrendMetricPipe } from '../../pipes/filter-trend-metric.pipe';
import { GroupByPipe } from '../../../shared/pipes/group-by.pipe';
import { OrderByPipe } from '../../../shared/pipes/order-by';
import { RegisterComponent } from '../../components/component-lookup';
import { MetricService } from '../../services/metric.service'; // Import the new service

@RegisterComponent('DecayMetricSelectorComponent')
@Component({
  selector: 'app-decay-metric-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, FilterTrendMetricPipe, GroupByPipe, OrderByPipe],
  templateUrl: './decay-metric-selector.component.html',
  styleUrl: './decay-metric-selector.component.scss',
})
export class DecayMetricSelectorComponent extends VisualBaseComponent {
  private sessionService = inject(SessionService);
  private metricStateService = inject(MetricService);

  readonly id = input.required<number>();
  readonly institution = inject(StateService).institution;

  listOpen = false;
  metric = signal<DecayMetric | undefined>(undefined);
  search = '';
  openCategories: string[] = [];
  decayMetrics = signal<DecayMetric[]>([]);
  onlyOneCategory = signal<boolean>(false);

  constructor() {
    super();

    effect(() => {
      const institution = this.institution();
      if (institution?.institutionType) {
        this.metricService.getDecayMetrics(institution.institutionType).subscribe((metrics) => {
          setTimeout(() => {
            this.decayMetrics.set(metrics);
            this.onlyOneCategory.set(this.hasOnlyOneDistinctValue(metrics,'categoryTitle'));
            const metricId =
              this.sessionService
                .get(`decay-metricId-${this.institution()?.institutionType}-${this.id()}`)
                ?.toString() ?? this.metric()?.metricId ?? metrics[0]?.metricId;
            this.selectMetric(metricId);
          });
        });
      }
    });
  }
  hasOnlyOneDistinctValue<T>(list: T[], property: keyof T): boolean {
    const uniqueValues = new Set(list.map((item) => item[property]));
    return uniqueValues.size === 1;
  }

  clearSearch() {
    this.search = '';
    this.openCategories = [];
  }

  isCategoryOpen(category: string) {
    return this.openCategories.find((c) => c == category);
  }

  toggleCategory(category: string) {
    if (this.openCategories.find((c) => c == category)) {
      this.openCategories = this.openCategories.filter((c) => c != category);
    } else {
      this.openCategories.push(category);
    }
  }

  selectMetric(metricId: string): void {
    const metric = this.decayMetrics().find((m) => m.metricId == metricId);
    if (metric) {
      this.sessionService.set(`decay-metricId-${this.institution()?.institutionType}-${this.id()}`, metricId, true);
      this.metric.set(metric);
      this.metricStateService.setSelecteDecaydMetric(metric);
      this.listOpen = false;
    }
  }
}